import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IProfileMassage, IUserProfile } from '../interfaces/IProfile';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profile = new ReplaySubject<IUserProfile>(null);
  constructor(private _httpClient: HttpClient) { }
  private _urlProfile = environment.baseUrl + 'accounts/profile/';


  getuserinfo(): Observable<IProfileMassage> {
    return this._httpClient.get<IProfileMassage>(this._urlProfile).pipe(map((response) => {
      this.profile.next(response.data)
      return response;
    }));
  }
}
